const PAYS_MAP = {
	suisse: "Suisse",
	schweiz: "Suisse",
	switzerland: "Suisse",
	svizzera: "Suisse",
	france: "France",
	frankreich: "France",
}

export function parseAdresseEmail(l0, l1, l2) {
	const result = {
		rue: "",
		numero: "",
		code_postal: "",
		localite: "",
		pays: "",
	}

	// --- Ligne 0 : rue + numéro ---
	const clean0 = (l0 || "").replace(/[,\s]+$/, "").trim()
	const numMatch = clean0.match(/^(.+?)\s+(\d+[a-z]?)\s*$/i)
	if (numMatch) {
		result.rue = numMatch[1].trim()
		result.numero = numMatch[2]
	} else {
		result.rue = clean0
	}

	// --- Ligne 1 : NPA + localité + éventuel pays ---
	const clean1 = (l1 || "").trim()
	const npaMatch = clean1.match(/^(\d{4,5})\s*(.*)$/)
	if (npaMatch) {
		result.code_postal = npaMatch[1]
		let reste = npaMatch[2].trim()

		// Chercher un token pays en fin de chaîne
		const tokens = reste.split(/\s+/)
		if (tokens.length > 0) {
			const last = tokens[tokens.length - 1].toLowerCase()
			if (PAYS_MAP[last]) {
				result.pays = PAYS_MAP[last]
				tokens.pop()
				reste = tokens.join(" ")
			}
		}
		// Nettoyer les résidus entre parenthèses et chiffres collés en fin
		result.localite = reste
			.replace(/\(.*?\)/g, "")
			.replace(/\d+\s*$/, "")
			.trim()
	}

	// --- Ligne 2 : pays (prioritaire si non vide) ---
	const clean2 = (l2 || "").trim()
	if (clean2) {
		const lower = clean2.toLowerCase()
		result.pays = PAYS_MAP[lower] || clean2
	}

	// --- Heuristique zip si pays encore vide ---
	if (!result.pays && result.code_postal) {
		if (result.code_postal.length === 4) result.pays = "Suisse"
		else if (result.code_postal.length === 5) result.pays = "France"
	}

	return result
}

// Localité depuis le NPA (localités chargées pour CE NPA) :
// - une localité déjà lisible dans l'e-mail reste prioritaire ;
// - 1 correspondance → localité + pays ;
// - plusieurs → la première, et `plusieurs: true` (l'appelant ouvre la liste
//   du NPA pour laisser choisir) ;
// - 0 → inchangé (localité vide).
export function resolveLocalite(parsed, localites) {
	if (parsed.localite || !parsed.code_postal || !localites) return parsed
	const matches = localites.filter(
		(l) => String(l.zip) === parsed.code_postal,
	)
	if (!matches.length) return parsed
	return {
		...parsed,
		localite: matches[0].nom,
		pays: matches[0].pays || parsed.pays,
		...(matches.length > 1 ? { plusieurs: true } : null),
	}
}
